import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, ViewController} from 'ionic-angular';

@Component({
  selector: 'page-edit-text',
  templateUrl: 'edit-text.html'
})
export class EditTextModal {
  @ViewChild('inputToFocus') inputToFocus;
  private textField: string;
  private title: string;

  constructor(public navCtrl: NavController, public navParams: NavParams, private viewCtrl: ViewController) {
    this.textField = navParams.get('editText');
    this.title = navParams.get('title') || "Tekstinvoer";
  }

  ionViewDidLoad(){
    setTimeout(() => {
      this.inputToFocus.setFocus();
    },500);
  }  

  dismiss() {
    this.viewCtrl.dismiss({text: this.textField});
  }

  cancel() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/modals/edit-text/edit-text.ts